<span class="form-input-editor">
  <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+ field) | translate" class="input-label"></label>
  <p-editor [id]="id" [(ngModel)]="value" (input)="onInput($event)"
    [readonly]="formControl['disabled']" [ngClass]="{ 'disabled': formControl['disabled'] }"
    [style]="{ height }">
    <p-header>
      <span class="ql-formats">
        <select class="ql-size">
          <option value="small">{{ 'primeng.editor.size.small' | translate }}</option>
          <option selected>{{ 'primeng.editor.size.normal' | translate }}</option>
          <option value="large">{{ 'primeng.editor.size.large' | translate }}</option>
          <option value="huge">{{ 'primeng.editor.size.huge' | translate }}</option>
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Bold"></button>
        <button class="ql-italic" aria-label="Italic"></button>
        <button class="ql-underline" aria-label="Underline"></button>
        <button class="ql-strike" aria-label="Strike"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered" title="{{ 'primeng.editor.list.ordered' | translate }}"></button>
        <button class="ql-list" value="bullet" title="{{ 'primeng.editor.list.bullet' | translate }}"></button>
        <select title="{{ 'primeng.editor.text-alignment' | translate }}" class="ql-align">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
      </span>
    </p-header>
  </p-editor>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
    [required]="formControl.errors?.['required']"
    [maxlength]="formControl.errors?.['maxlength']"></app-form-input-error>
</span>
